export const PERMISSION_INVITE_USERS   = 0x0000000000010000;
export const PERMISSION_MANAGE_USERS   = 0x0000000000000400;
export const PERMISSION_MANAGE_REPORTS = 0x0000000000000010;
